import { Col, Row, Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { EventCard } from 'components/models/events/EventCard'
import { Section } from 'components/pages/root/Section'
import { Loading } from 'components/shared/Loading'
import { useOwnerEventsPast, useOwnerEventsUpcoming } from 'hooks/owners'
import { useOwnerEventsOngoing } from 'hooks/owners/useOwnerEventsOngoing'
import { isEmpty, slice } from 'lodash'
import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import { VFC } from 'react'

import { TopContentSecondary } from '../TopContentSecondary'

type Props = {
  owner: Owner
}

export const EventTab: VFC<Props> = ({ owner }) => {
  const { xs } = useBreakpoint()
  const { t } = useTranslation()

  const { data: eventsOngoing = [], isValidating: isValidatingEventsOngoing } =
    useOwnerEventsOngoing({ ownerId: owner.id, limit: 10 })
  const {
    data: eventsUpcoming = [],
    isValidating: isValidatingEventsUpcoming,
  } = useOwnerEventsUpcoming({ ownerId: owner.id, limit: 10 })
  const { data: eventsPast = [], isValidating: isValidatingEventsPast } =
    useOwnerEventsPast({ ownerId: owner.id })

  const isLoading =
    isValidatingEventsOngoing ||
    isValidatingEventsUpcoming ||
    isValidatingEventsPast
  const isDisplayEmptyStatus =
    isEmpty(eventsOngoing) && isEmpty(eventsUpcoming) && isEmpty(eventsPast)
  if (isLoading) {
    return (
      <div style={{ paddingTop: xs ? 40 : 60 }}>
        <Loading />
      </div>
    )
  }

  if (isDisplayEmptyStatus) {
    return (
      <div
        style={{
          paddingTop: 100,
          paddingBottom: 100,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: 24,
          justifyContent: 'center',
        }}
      >
        <Image src="/no-objects/event.png" width={130} height={130} />
        <Typography.Text style={{ fontSize: 16, lineHeight: 1 }}>
          {t('公開イベントはありません')}
        </Typography.Text>
      </div>
    )
  }

  return (
    <div style={{ padding: xs ? '40px 16px' : '60px 64px' }}>
      <TopContentSecondary events={slice(eventsOngoing, 5)} />
      {!isEmpty(eventsOngoing) && (
        <Section title={t('開催中のイベント')}>
          <Row gutter={[24, 24]} style={{ paddingTop: 24, paddingBottom: 24 }}>
            {eventsOngoing.map((event) => (
              <Col key={event.id} xs={12} md={6} style={{ width: '100%' }}>
                <EventCard
                  event={event}
                  style={{ width: '100%', minWidth: 'unset' }}
                />
              </Col>
            ))}
          </Row>
        </Section>
      )}
      {!isEmpty(eventsUpcoming) && (
        <Section title={t('開催予定のイベント')}>
          <Row gutter={[24, 24]} style={{ paddingTop: 24, paddingBottom: 24 }}>
            {eventsUpcoming.map((event) => (
              <Col key={event.id} xs={12} md={6} style={{ width: '100%' }}>
                <EventCard
                  event={event}
                  style={{ width: '100%', minWidth: 'unset' }}
                />
              </Col>
            ))}
          </Row>
        </Section>
      )}
      {!isEmpty(eventsPast) && (
        <Section title={t('過去のイベント')}>
          <Row gutter={[24, 24]} style={{ paddingTop: 24, paddingBottom: 24 }}>
            {eventsPast.map((event) => (
              <Col key={event.id} xs={12} md={6} style={{ width: '100%' }}>
                <EventCard
                  event={event}
                  style={{ width: '100%', minWidth: 'unset' }}
                />
              </Col>
            ))}
          </Row>
        </Section>
      )}
    </div>
  )
}
